/** ProFind production Supabase client. Only the public browser key belongs here. */
(function () {
  'use strict';

  var SUPABASE_URL = 'https://lzcpiphfoscznxfxzqqz.supabase.co';
  var SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_eha-K_a50XQclN3nKDrNew_sb3QSEQn';
  var _client = null;
  var _ready = false;
  var _readyCallbacks = [];
  var _queryCache = {};

  function cachedCall(key, ttl, factory) {
    var now = Date.now();
    var existing = _queryCache[key];
    if (existing && existing.value && now - existing.at < ttl) return Promise.resolve(existing.value);
    if (existing && existing.promise) return existing.promise;
    var promise = Promise.resolve().then(factory).then(function (result) {
      if (!result || !result.error) _queryCache[key] = { value: result, at: Date.now(), promise: null };
      else delete _queryCache[key];
      return result;
    }).catch(function (error) {
      delete _queryCache[key];
      throw error;
    });
    _queryCache[key] = { value: null, at: 0, promise: promise };
    return promise;
  }
  function clearQueryCache(prefix) {
    Object.keys(_queryCache).forEach(function (key) {
      if (!prefix || key.indexOf(prefix) === 0) delete _queryCache[key];
    });
  }

  function initClient() {
    if (_client) return _client;
    if (!window.supabase) return null;
    _client = window.supabase.createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true }
    });
    return _client;
  }
  function onReady(cb) { if (_ready) { cb(); return; } _readyCallbacks.push(cb); }
  document.addEventListener('DOMContentLoaded', function () {
    initClient(); _ready = true;
    _readyCallbacks.forEach(function (cb) { cb(); }); _readyCallbacks = [];
  });

  function friendlyError(error, fallback) {
    var rawMessage = String((error && error.message) || '');
    var message = rawMessage.toLowerCase();
    var status = error && error.status;
    if (message.indexOf('invalid login credentials') >= 0) return 'The email or password is incorrect.';
    if (message.indexOf('email not confirmed') >= 0) return 'Please confirm your email before signing in.';
    if (message.indexOf('already registered') >= 0 || message.indexOf('already been registered') >= 0) return 'An account already exists for this email. Please sign in instead.';
    if (message.indexOf('password') >= 0 && (message.indexOf('weak') >= 0 || message.indexOf('least') >= 0)) return 'Choose a stronger password with at least 8 characters, including a number and symbol.';
    if (message === 'choose a jpg, png or webp image smaller than 8 mb.' ||
        message === 'choose a pdf, jpg or png file smaller than 12 mb.' ||
        message === 'consent is required before uploading a verification document.' ||
        message === 'please sign in again.') return error.message;
    if (status === 429 || message.indexOf('rate limit') >= 0 || message.indexOf('too many') >= 0) return 'Too many attempts. Please wait a few minutes and try again.';
    if (message.indexOf('network') >= 0 || message.indexOf('fetch') >= 0) return 'We couldn\'t connect to ProFind. Check your connection and try again.';
    // Only genericize when the message would leak backend implementation
    // details — a raw URL, an infra/service name, or a raw database error
    // (constraint/relation/column/RLS names). Anything else that reaches
    // here is presumed to be an ordinary, safe application-level message an
    // Edge Function chose to return (e.g. "This document could not be
    // processed", "A verification is already pending for this business")
    // and is shown as-is rather than replaced with a generic fallback.
    // Previously EVERY unrecognized message was discarded here, which
    // meant save-business-profile / upload-business-verification-document
    // could return a perfectly useful, specific reason and the business
    // owner would only ever see "Something went wrong" — this is the fix
    // for that.
    if (
      /https?:\/\//i.test(rawMessage) ||
      /supabase|postgres|webhook|edge function|storage bucket|\bsql\b|constraint|relation "|column "|permission denied for|row-level security|didit|paystack|\bapi[_\s]?key\b|service[_\s]?role/i.test(message)
    ) return fallback || 'We couldn\'t complete that request right now. Please try again shortly.';
    if (rawMessage && rawMessage.length <= 300) return rawMessage;
    return fallback || 'We couldn\'t complete that request. Please try again.';
  }

  function mapped(promise, mapper) {
    return promise.then(function (res) {
      if (!res.error && res.data != null) res.data = mapper(res.data);
      return res;
    });
  }
  function computeBusinessOpenState(hoursRows) {
    var result = { open_now:false, closing_soon:false, closes_in_minutes:null };
    var rows = Array.isArray(hoursRows) ? hoursRows : [];
    if (!rows.length) return result;
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone:'Africa/Johannesburg', weekday:'short', hour:'2-digit', minute:'2-digit', hourCycle:'h23'
    }).formatToParts(new Date());
    var values = {};
    parts.forEach(function (p) { values[p.type] = p.value; });
    var dayMap = {Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6};
    var day = dayMap[values.weekday];
    var nowMinutes = Number(values.hour || 0) * 60 + Number(values.minute || 0);
    function mins(t) {
      if (!t) return null;
      var p = String(t).slice(0,5).split(':');
      return Number(p[0]) * 60 + Number(p[1]);
    }
    function rowFor(d) { return rows.find(function (r) { return Number(r.day_of_week) === d; }); }
    var today = rowFor(day);
    var previous = rowFor((day + 6) % 7);
    if (today && !today.is_closed) {
      if (today.is_24_hours) return { open_now:true, closing_soon:false, closes_in_minutes:null };
      var open = mins(today.opens_at), close = mins(today.closes_at);
      if (open != null && close != null) {
        if (close > open && nowMinutes >= open && nowMinutes < close) {
          result.open_now = true; result.closes_in_minutes = close - nowMinutes;
        } else if (close <= open && nowMinutes >= open) {
          result.open_now = true; result.closes_in_minutes = (1440 - nowMinutes) + close;
        }
      }
    }
    if (!result.open_now && previous && !previous.is_closed && !previous.is_24_hours) {
      var prevOpen = mins(previous.opens_at), prevClose = mins(previous.closes_at);
      if (prevOpen != null && prevClose != null && prevClose <= prevOpen && nowMinutes < prevClose) {
        result.open_now = true; result.closes_in_minutes = prevClose - nowMinutes;
      }
    }
    result.closing_soon = result.open_now && result.closes_in_minutes != null && result.closes_in_minutes <= 60;
    return result;
  }

  function mapBusiness(b) {
    if (!b) return b;
    b.business_name = b.name; b.shopify_handle = b.slug; b.primary_category = b.category;
    b.short_description = b.description; b.full_description = b.description;
    b.verification_status = b.business_verified ? 'VERIFIED' : 'NOT VERIFIED';
    b.handle = b.slug;
    b.profile_path = '/pages/find-a-pro?business=' + encodeURIComponent(b.slug || '');
    b.logo = b.logo_url || '';
    b.cover = b.cover_url || '';
    b.rating = Number(b.average_rating || 0);
    b.reviews = Number(b.review_count || 0);
    b.verified = !!b.business_verified;
    if (Array.isArray(b.service_areas)) b.service_areas = b.service_areas.filter(function(area){ return area.plan_active !== false; });
    var primaryArea = (b.service_areas || []).filter(function (area) { return area.is_primary; })[0] || (b.service_areas || [])[0];
    b.lat = b.latitude == null ? (primaryArea && primaryArea.latitude != null ? Number(primaryArea.latitude) : null) : Number(b.latitude);
    b.lng = b.longitude == null ? (primaryArea && primaryArea.longitude != null ? Number(primaryArea.longitude) : null) : Number(b.longitude);
    b.locality = [b.suburb, b.city, b.province].filter(Boolean).join(', ');
    b.additional_categories = '';
    var servicesRaw = b.services || [];
    b.services_text = servicesRaw.map(function (service) { return service.name; }).join(', ');
    var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var schedule = {};
    (b.business_hours || []).forEach(function (row) {
      if (row.is_closed) return;
      schedule[dayNames[row.day_of_week]] = row.is_24_hours ? '00:00 - 23:59' : ((row.opens_at || '').slice(0, 5) + ' - ' + (row.closes_at || '').slice(0, 5));
    });
    b.hours = JSON.stringify(schedule);
    var openState = computeBusinessOpenState(b.business_hours || []);
    b.open_now = openState.open_now;
    b.closing_soon = openState.closing_soon;
    b.closes_in_minutes = openState.closes_in_minutes;
    var availability = Array.isArray(b.business_availability) ? b.business_availability[0] : b.business_availability;
    b.available_now = !!(availability && availability.available_now);
    b.accepting_enquiries = !availability || availability.accepting_enquiries !== false;
    b.enquiry_pause_until = availability && availability.enquiry_pause_until || null;
    b.response_time_minutes = availability && availability.response_time_minutes != null ? Number(availability.response_time_minutes) : null;
    var emergencyServices = servicesRaw;
    b.emergency = b.is_emergency_enabled && availability ? {
      callouts_enabled: true,
      available_now: !!availability.emergency_available,
      services: Array.isArray(emergencyServices) ? emergencyServices.filter(function (service) { return service.is_emergency_service; }).map(function (service) { return service.name; }).join(', ') : '',
      service_radius_km: availability.emergency_radius_km != null ? Number(availability.emergency_radius_km) : null,
      service_areas: (b.service_areas || []).map(function (area) { return area.area_name; }).join(', '),
      typical_response_minutes: availability.response_time_minutes,
      emergency_status: 'ACTIVE'
    } : null;
    var activeOffers = (b.offers || []).filter(function (offer) { return offer.status === 'ACTIVE'; });
    if (activeOffers.length) {
      activeOffers.sort(function (a,b2) { return new Date(a.ends_at || 0) - new Date(b2.ends_at || 0); });
      var offer = activeOffers[0];
      var discountLabel = offer.description || offer.title || 'Special offer';
      if (offer.discount_type === 'PERCENTAGE' && offer.discount_value != null) discountLabel = String(Number(offer.discount_value)) + '% off';
      else if (offer.discount_type === 'FIXED_AMOUNT' && offer.discount_value != null) discountLabel = 'R' + Number(offer.discount_value).toLocaleString('en-ZA') + ' off';
      b.offer = {
        id: offer.id,
        handle: offer.id,
        title: offer.title,
        discount: discountLabel,
        service: offer.applicable_service || '',
        terms: offer.terms || '',
        exclusions: offer.exclusions || '',
        end_date: offer.ends_at
      };
    } else b.offer = null;
    return b;
  }
  function mapService(s) { s.service_name = s.name; return s; }
  function mapEnquiry(e) {
    e.service_requested = e.subject || 'Enquiry';
    if (e.business) mapBusiness(e.business);
    if (e.messages) e.messages.sort(function (a, b) { return new Date(a.created_at) - new Date(b.created_at); });
    if (e.messages && e.messages.length) e.business_response = e.messages[e.messages.length - 1].body;
    return e;
  }
  function mapReview(r) {
    r.overall_rating = r.rating; r.review_text = r.body; r.business_reply = r.business_response;
    if (r.business) mapBusiness(r.business);
    return r;
  }
  function mapOffer(o) {
    o.active = o.status === 'ACTIVE'; o.discount_label = o.description;
    o.start_date = o.starts_at; o.end_date = o.ends_at;
    return o;
  }
  function authHeaders(session, includeJson) {
    var headers = { 'apikey': SUPABASE_PUBLISHABLE_KEY };
    var token = session && session.access_token;
    if (token) headers.Authorization = 'Bearer ' + token;
    if (includeJson) headers['Content-Type'] = 'application/json';
    return headers;
  }

  function currentSession(forceRefresh) {
    var client = initClient();
    if (!client) return Promise.resolve({ data: { session: null }, error: { message: 'ProFind is still loading. Please try again.' } });
    return (forceRefresh ? client.auth.refreshSession() : client.auth.getSession()).then(function (res) {
      if (res.error) return { data: { session: null }, error: res.error };
      return res;
    });
  }

  function parseFunctionResponse(response) {
    return response.text().then(function (raw) {
      var body = {};
      if (raw) {
        try { body = JSON.parse(raw); }
        catch (_e) { body = { error: raw }; }
      }
      return { response: response, body: body };
    });
  }

  // Safe, local-only diagnostic log (browser console — never sent
  // anywhere, never includes the auth token, the request payload, or a
  // raw stack trace). Gives an engineer looking at a business owner's
  // console (or asking them to screenshot it) the function name, HTTP
  // status and a short error kind, without exposing anything sensitive.
  function logFunctionDiagnostic(name, status, kind, detail) {
    try {
      if (window.console && console.error) {
        console.error('[ProFind]', name, 'failed —', 'status:', status, 'kind:', kind, detail ? ('detail: ' + String(detail).slice(0, 200)) : '');
      }
    } catch (e) { /* never let logging itself break the call */ }
  }

  function functionError(name, body, status, fallback) {
    var message = body && (body.error || body.message || body.msg);
    var code = body && body.code ? String(body.code) : null;
    logFunctionDiagnostic(name, status, status === 401 ? 'auth' : (status >= 500 ? 'server' : 'client'), message);
    if (status === 401) message = 'Please sign in again.';
    if (code === 'ID_NUMBER_REQUIRED') {
      return { data: null, error: { message: 'Enter and save your South African ID number before starting identity verification.', status: status, code: code } };
    }
    if (code === 'VERIFICATION_NOT_CONFIGURED' || code === 'VERIFICATION_PROVIDER_UNAVAILABLE') {
      return { data: null, error: { message: 'Identity verification is temporarily unavailable. Please try again shortly.', status: status, code: code } };
    }
    return { data: null, error: { message: friendlyError({ message: message || fallback, status: status }, fallback), status: status, code: code } };
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    timeoutMs=Math.max(1000,Number(timeoutMs)||30000);
    if(window.AbortController){
      var controller=new AbortController();
      var timer=window.setTimeout(function(){controller.abort();},timeoutMs);
      var nextOptions=Object.assign({},options||{},{signal:controller.signal});
      return fetch(url,nextOptions).then(function(response){
        window.clearTimeout(timer);
        return response;
      }).catch(function(error){
        window.clearTimeout(timer);
        if(error&&error.name==='AbortError'){
          var timeoutError=new Error('Request timed out');
          timeoutError.name='TimeoutError';
          throw timeoutError;
        }
        throw error;
      });
    }
    return Promise.race([
      fetch(url,options),
      new Promise(function(_resolve,reject){
        window.setTimeout(function(){
          var timeoutError=new Error('Request timed out');
          timeoutError.name='TimeoutError';
          reject(timeoutError);
        },timeoutMs);
      })
    ]);
  }

  function invokePublicFunction(name, payload, timeoutMs) {
    timeoutMs=Math.max(1000,Number(timeoutMs)||(name==='now-ai-search'?15000:30000));
    return currentSession(false).catch(function(){ return {data:{session:null},error:null}; }).then(function(sessionRes){
      var session=sessionRes&&sessionRes.data&&sessionRes.data.session;
      return fetchWithTimeout(SUPABASE_URL + '/functions/v1/' + name, {
        method:'POST',
        headers:authHeaders(session,true),
        body:JSON.stringify(payload||{})
      },timeoutMs).then(parseFunctionResponse).then(function(result){
        return result.response.ok
          ? {data:result.body,error:null}
          : functionError(name,result.body,result.response.status,'We couldn\'t complete that request right now.');
      }).catch(function(error){
        var timedOut=!!(error&&error.name==='TimeoutError');
        logFunctionDiagnostic(name,0,timedOut?'timeout':'network',null);
        return timedOut
          ? {data:null,error:{message:'This request took too long. Please try again.',timeout:true}}
          : {data:null,error:{message:'We couldn\'t connect to ProFind. Check your connection and try again.',network:true}};
      });
    });
  }

  function invokePublicFunctionForm(name, formData, timeoutMs) {
    timeoutMs=Math.max(1000,Number(timeoutMs)||60000);
    return currentSession(false).catch(function(){ return {data:{session:null},error:null}; }).then(function(sessionRes){
      var session=sessionRes&&sessionRes.data&&sessionRes.data.session;
      return fetchWithTimeout(SUPABASE_URL + '/functions/v1/' + name, {
        method:'POST',
        headers:authHeaders(session,false),
        body:formData
      },timeoutMs).then(parseFunctionResponse).then(function(result){
        return result.response.ok
          ? {data:result.body,error:null}
          : functionError(name,result.body,result.response.status,'We couldn\'t upload this file. Please try again.');
      }).catch(function(error){
        var timedOut=!!(error&&error.name==='TimeoutError');
        logFunctionDiagnostic(name,0,timedOut?'timeout':'network',null);
        return timedOut
          ? {data:null,error:{message:'This upload took too long. Please try again.',timeout:true}}
          : {data:null,error:{message:'We couldn\'t connect to ProFind. Check your connection and try again.',network:true}};
      });
    });
  }

  function invokeFunction(name, payload) {
    function send(session, canRetry) {
      if (!session || !session.access_token) return Promise.resolve({ data: null, error: { message: 'Please sign in again.' } });
      var timeoutMs = name === 'now-ai-search' ? 15000 : 30000;
      return fetchWithTimeout(SUPABASE_URL + '/functions/v1/' + name, {
        method: 'POST',
        headers: authHeaders(session, true),
        body: JSON.stringify(payload || {})
      }, timeoutMs).then(parseFunctionResponse).then(function (result) {
        if (result.response.status === 401 && canRetry) {
          return currentSession(true).then(function (refresh) {
            if (refresh.error || !refresh.data || !refresh.data.session) return { data: null, error: { message: 'Please sign in again.' } };
            return send(refresh.data.session, false);
          });
        }
        return result.response.ok ? { data: result.body, error: null } : functionError(name, result.body, result.response.status, 'We couldn\'t complete that request right now.');
      }).catch(function (error) {
        var timedOut=!!(error&&error.name==='TimeoutError');
        logFunctionDiagnostic(name,0,timedOut?'timeout':'network',null);
        return timedOut
          ? { data:null, error:{ message:'This request took too long. Please try again.', timeout:true } }
          : { data:null, error:{ message:'We couldn\'t connect to ProFind. Check your connection and try again.', network:true } };
      });
    }
    return currentSession(false).then(function (sessionRes) {
      if (sessionRes.error || !sessionRes.data || !sessionRes.data.session) return { data: null, error: { message: 'Please sign in again.' } };
      return send(sessionRes.data.session, true);
    });
  }

  function invokeFunctionForm(name, formData) {
    function send(session, canRetry) {
      if (!session || !session.access_token) return Promise.resolve({ data: null, error: { message: 'Please sign in again.' } });
      return fetchWithTimeout(SUPABASE_URL + '/functions/v1/' + name, {
        method: 'POST',
        headers: authHeaders(session, false),
        body: formData
      }, 60000).then(parseFunctionResponse).then(function (result) {
        if (result.response.status === 401 && canRetry) {
          return currentSession(true).then(function (refresh) {
            if (refresh.error || !refresh.data || !refresh.data.session) return { data: null, error: { message: 'Please sign in again.' } };
            return send(refresh.data.session, false);
          });
        }
        return result.response.ok ? { data: result.body, error: null } : functionError(name, result.body, result.response.status, 'We couldn\'t upload this file. Please try again.');
      }).catch(function (error) {
        var timedOut=!!(error&&error.name==='TimeoutError');
        logFunctionDiagnostic(name,0,timedOut?'timeout':'network',null);
        return timedOut
          ? { data:null, error:{ message:'This upload took too long. Please try again.', timeout:true } }
          : { data:null, error:{ message:'We couldn\'t connect to ProFind. Check your connection and try again.', network:true } };
      });
    }
    return currentSession(false).then(function (sessionRes) {
      if (sessionRes.error || !sessionRes.data || !sessionRes.data.session) return { data: null, error: { message: 'Please sign in again.' } };
      return send(sessionRes.data.session, true);
    });
  }

  function fileExtension(file) {
    var byType = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'application/pdf': 'pdf' };
    return byType[file.type] || 'bin';
  }

  function uniqueStoragePath(userId, businessId, prefix, file) {
    var id = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(16).slice(2));
    return userId + '/' + businessId + '/' + prefix + '-' + id + '.' + fileExtension(file);
  }

  var ProFindAuth = {
    getSession: function () { return initClient().auth.getSession(); },
    signUp: function (email, password, fullName, phone) {
      return initClient().auth.signUp({
        email: email,
        password: password,
        options: {
          emailRedirectTo: window.location.origin + '/pages/login' + (function(){
            try { return localStorage.getItem('profind_pending_claim_token') ? '?claim_pending=1' : ''; }
            catch(_e) { return ''; }
          })(),
          data: { full_name: fullName, phone: phone }
        }
      });
    },
    startBusinessRegistration: function (email, businessName, phone, category, planIntent) {
      var bytes = new Uint8Array(24);
      window.crypto.getRandomValues(bytes);
      var alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%';
      var temporaryPassword = 'Pf!9' + Array.prototype.map.call(bytes, function (value) {
        return alphabet.charAt(value % alphabet.length);
      }).join('');
      return initClient().auth.signUp({
        email: email,
        password: temporaryPassword,
        options: {
          emailRedirectTo: window.location.origin + '/pages/verify-business-email',
          data: {
            business_onboarding_pending: true,
            business_name: businessName,
            business_phone: phone,
            business_category: category,
            business_plan_intent: ['STANDARD','PRO'].indexOf(String(planIntent || '').toUpperCase()) >= 0 ? String(planIntent).toUpperCase() : 'FREE'
          }
        }
      }).then(function (result) {
        if (result.error) return result;
        var user = result.data && result.data.user;
        var identities = user && Array.isArray(user.identities) ? user.identities : null;
        if (user && identities && identities.length === 0) {
          return { data: result.data, error: null, existing_account: true };
        }
        return result;
      });
    },
    prepareExistingBusinessRegistration: function (businessName, phone, category, planIntent) {
      return initClient().auth.updateUser({
        data: {
          business_onboarding_pending: true,
          business_name: businessName,
          business_phone: phone,
          business_category: category,
          business_plan_intent: ['STANDARD','PRO'].indexOf(String(planIntent || '').toUpperCase()) >= 0 ? String(planIntent).toUpperCase() : 'FREE'
        }
      });
    },
    resendBusinessVerification: function (email) {
      return initClient().auth.resend({
        type: 'signup',
        email: email,
        options: { emailRedirectTo: window.location.origin + '/pages/verify-business-email' }
      });
    },
    signIn: function (email, password) { return initClient().auth.signInWithPassword({ email: email, password: password }); },
    signOut: function () {
      var before = (typeof window.ProFindNotificationBeforeSignOut === 'function')
        ? Promise.resolve().then(function(){ return window.ProFindNotificationBeforeSignOut(); }).catch(function(){})
        : Promise.resolve();
      return Promise.race([
        before,
        new Promise(function(resolve){ window.setTimeout(resolve, 1500); })
      ]).then(function(){ return initClient().auth.signOut(); });
    },
    resetPasswordForEmail: function (email, redirectPath) {
      var safePath = (redirectPath && redirectPath.indexOf('/pages/') === 0 && redirectPath.indexOf('//') !== 0)
        ? redirectPath
        : '/pages/login?mode=reset';
      return initClient().auth.resetPasswordForEmail(email, { redirectTo: window.location.origin + safePath });
    },
    updatePassword: function (password) { return initClient().auth.updateUser({ password: password }); },
    finishBusinessRegistration: function () { return initClient().auth.updateUser({ data: { business_onboarding_pending: false } }); },
    // Clears the pricing-page plan selection captured at registration
    // (business_plan_intent) once it's either been acted on (a confirmed
    // upgrade) or deliberately dismissed in the Business Back Office
    // billing banner. Never changes business_onboarding_pending or any
    // other metadata key.
    clearPlanIntent: function () { return initClient().auth.updateUser({ data: { business_plan_intent: null } }); },
    errorMessage: friendlyError,
    onAuthStateChange: function (cb) {
      onReady(function () {
        initClient().auth.getSession().then(function (res) { cb(res.data.session); });
        initClient().auth.onAuthStateChange(function (_event, session) { cb(session); });
      });
    }
  };

  var ProFindData = {
    client: function () { return initClient(); },
    getPublicBusinesses: function () {
      return mapped(
        initClient().rpc('profind_public_business_directory'),
        function (rows) { return (rows || []).map(mapBusiness); }
      );
    },
    getEmergencyFallbackBusinesses: function (category, latitude, longitude, maxResults) {
      return mapped(initClient().rpc('emergency_fallback_businesses',{
        wanted_category:String(category||'').trim(),
        wanted_lat:latitude==null?null:Number(latitude),
        wanted_lon:longitude==null?null:Number(longitude),
        max_results:Math.max(1,Math.min(20,Number(maxResults)||8))
      }), function(rows) {
        return (rows||[]).map(function(row) {
          row.id=row.business_id;
          row.profile_path='/pages/find-a-pro?business='+encodeURIComponent(row.slug||'');
          row.logo=row.logo_url||'';
          row.rating=Number(row.average_rating||0);
          row.reviews=Number(row.review_count||0);
          row.lat=row.latitude==null?null:Number(row.latitude);
          row.lng=row.longitude==null?null:Number(row.longitude);
          row.locality=[row.suburb,row.city,row.province].filter(Boolean).join(', ');
          row.open_now=!!row.available_now;
          row.accepting_enquiries=true;
          return row;
        });
      });
    },
    getPublicBusiness: function (slug) {
      return mapped(
        initClient().rpc('profind_public_business_profile',{target_slug:String(slug||'').trim().toLowerCase()}),
        mapBusiness
      );
    },
    getMyProfile: function () { return initClient().from('profiles').select('*').single(); },
    updateMyProfile: function (fields) {
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data: null, error: { message: 'Please sign in again.' } };
        var uid=res.data.user.id;
        return initClient().from('profiles').select('notification_preferences').eq('id',uid).single().then(function(current){
          if(current.error) return current;
          var prefs=Object.assign({},(current.data&&current.data.notification_preferences)||{},{
            email: !!fields.email_notifications,
            marketing_email: !!fields.marketing_email,
            sms: false
          });
          return initClient().from('profiles').update({
            full_name: (fields.full_name || '').trim() || null,
            phone: (fields.phone || '').trim() || null,
            preferred_area: (fields.preferred_area || '').trim() || null,
            search_radius_km: Math.min(60, Math.max(1, Number(fields.search_radius_km) || 15)),
            notification_preferences: prefs
          }).eq('id',uid).select('*').single();
        });
      });
    },
    updateMyNotificationPreferences: function (fields) {
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data: null, error: { message: 'Please sign in again.' } };
        var uid=res.data.user.id;
        return initClient().from('profiles').select('notification_preferences').eq('id',uid).single().then(function(current){
          if(current.error) return current;
          var prefs=Object.assign({},(current.data&&current.data.notification_preferences)||{},{
            email: !!fields.email,
            marketing_email: !!fields.marketing_email,
            sms: false
          });
          return initClient().from('profiles').update({ notification_preferences:prefs })
            .eq('id',uid).select('*').single();
        });
      });
    },
    getMyFavourites: function () {
      return mapped(initClient().from('favourites').select('business_id,created_at,business:businesses(id,slug,name,category)').order('created_at', { ascending: false }), function (rows) {
        return rows.map(function (row) { mapBusiness(row.business); return row; });
      });
    },
    addFavourite: function (businessId) {
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data:null, error:{ message:'Please sign in to save this business.' } };
        return initClient().from('favourites').upsert({ business_id: businessId, user_id: res.data.user.id }, { onConflict:'user_id,business_id' });
      });
    },
    removeFavourite: function (businessId) {
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data:null, error:{ message:'Please sign in to manage saved businesses.' } };
        return initClient().from('favourites').delete().eq('business_id', businessId).eq('user_id', res.data.user.id);
      });
    },
    getMyFollows: function () {
      return mapped(initClient().from('business_follows').select('business_id,notifications_enabled,created_at,business:businesses(id,slug,name,category)').order('created_at', { ascending: false }), function (rows) {
        return rows.map(function (row) { mapBusiness(row.business); return row; });
      });
    },
    updateFollowNotifications: function (businessId, enabled) {
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data:null, error:{ message:'Please sign in again.' } };
        return initClient().from('business_follows').update({ notifications_enabled:!!enabled }).eq('user_id', res.data.user.id).eq('business_id', businessId);
      });
    },
    getMyEnquiries: function () {
      return mapped(initClient().rpc('get_my_enquiries_inbox', { limit_rows: 100 }), function (rows) {
        return (Array.isArray(rows) ? rows : []).map(mapEnquiry);
      });
    },
    getMyEmergencyHistory: function () {
      return mapped(initClient().from('emergency_requests')
        .select('*,business:businesses(name,slug,phone,address_line1,address_line2,suburb,city,province,latitude,longitude),responder:emergency_responders(display_name,status,verification_status,vehicle_color,vehicle_make,vehicle_model,vehicle_registration,vehicle_type,vehicle_verification_status)')
        .order('created_at', { ascending: false }), function (rows) {
        return rows.map(function (r) {
          r.service_category = r.category;
          r.area_label = r.area_name;
          r.responding_business_name = r.business && r.business.name;
          return r;
        });
      });
    },
    getEmergencyRequest: function (id) {
      return initClient().from('emergency_requests')
        .select('*,business:businesses(name,slug,phone,address_line1,address_line2,suburb,city,province,latitude,longitude),responder:emergency_responders(display_name,mobile_phone,status,verification_status,vehicle_color,vehicle_make,vehicle_model,vehicle_registration,vehicle_type,vehicle_verification_status)')
        .eq('id', id).maybeSingle();
    },
    getMyEmergencyTracking: function (requestId) {
      return initClient().rpc('get_my_emergency_tracking', { target_request: requestId });
    },
    manageEmergencyRequest: function (requestId, manageToken, action, reason, extra) {
      return invokePublicFunction('manage-emergency-request', Object.assign({
        request_id: requestId,
        manage_token: manageToken || null,
        action: action || 'STATUS',
        reason: reason || null
      }, extra || {}), 20000);
    },
    emergencyNavigation: function (requestId, viewer, options) {
      return invokePublicFunction('emergency-navigation', Object.assign({
        request_id: requestId,
        viewer: String(viewer || 'CUSTOMER').toUpperCase()
      }, options || {}), 20000);
    },
    manageEmergencyPayment: function (requestId, manageToken, action, email, reference) {
      return invokeFunction('paystack-emergency-payment', {
        request_id:requestId,
        manage_token:manageToken,
        action:String(action||'INITIALIZE').toUpperCase(),
        email:(email||'').trim(),
        reference:reference||null
      });
    },
    uploadEmergencyVoice: function (requestId, voiceUploadToken, durationSeconds, audioBlob) {
      if (!voiceUploadToken) return Promise.resolve({ data: null, error: { message: 'Voice notes are not available for this request.' } });
      if (!audioBlob || !audioBlob.size) return Promise.resolve({ data: null, error: { message: 'No recording to upload.' } });
      var extByType = { 'audio/webm': 'webm', 'audio/ogg': 'ogg', 'audio/mp4': 'm4a', 'audio/mpeg': 'mp3', 'audio/aac': 'aac', 'audio/wav': 'wav', 'audio/x-m4a': 'm4a' };
      var ext = extByType[audioBlob.type] || 'webm';
      var form = new FormData();
      form.append('request_id', requestId);
      form.append('voice_upload_token', voiceUploadToken);
      form.append('duration_seconds', String(Math.round(durationSeconds || 0)));
      form.append('audio', audioBlob, 'voice-note.' + ext);
      return invokePublicFunctionForm('upload-emergency-voice', form, 60000);
    },

    // FIX 2026-09-19: get-emergency-voice-url contract confirmed empirically
    // against the live deployed function (auth-required 401, request_id
    // validation 400, not-found 404 all matched exactly) rather than
    // inferred, per the "do not invent Edge Function contracts" rule. Server
    // authorizes the caller as either the emergency's customer or a member
    // of the assigned business; returns a signed URL valid 300 seconds, so
    // callers must re-request it fresh each time rather than caching it.
    getEmergencyVoiceUrl: function (requestId) {
      return invokeFunction('get-emergency-voice-url', { request_id: requestId });
    },
    getMyOfferClaims: function () {
      return mapped(initClient().from('offer_claims').select('*,offer:offers(id,business_id,applicable_service_id,business:businesses(id,name,slug))').order('created_at', { ascending: false }), function (rows) {
        return rows.map(function (c) {
          c.claimed_at = c.created_at;
          c.claim_reference = c.claim_code;
          var discount = c.snapshot_description || '';
          if (c.snapshot_discount_type === 'PERCENTAGE' && c.snapshot_discount_value != null) discount = String(Number(c.snapshot_discount_value)) + '% off';
          else if (c.snapshot_discount_type === 'FIXED_AMOUNT' && c.snapshot_discount_value != null) discount = 'R' + Number(c.snapshot_discount_value).toLocaleString('en-ZA') + ' off';
          c.snapshot_discount = discount;
          return c;
        });
      });
    },
    getMyReviews: function () {
      return mapped(initClient().from('reviews').select('id,enquiry_id,rating,title,body,business_response,status,created_at,business:businesses(id,name,slug)').order('created_at', { ascending: false }), function (rows) { return rows.map(mapReview); });
    },
    createReview: function (enquiryId, businessId, rating, title, body) {
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data:null, error:{ message:'Please sign in again.' } };
        return initClient().from('reviews').insert({
          enquiry_id: enquiryId,
          business_id: businessId,
          user_id: res.data.user.id,
          rating: Number(rating),
          title: (title || '').trim() || null,
          body: (body || '').trim() || null,
          status: 'PENDING'
        }).select('id,enquiry_id,rating,title,body,status,created_at').single();
      });
    },
    reportReview: function (reviewId, reason, details) {
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data:null, error:{ message:'Please sign in to report this review.' } };
        return initClient().from('review_reports').insert({
          review_id: reviewId,
          reporter_id: res.data.user.id,
          reason: (reason || 'OTHER').trim().slice(0,120),
          details: (details || '').trim().slice(0,2000) || null,
          status: 'OPEN'
        }).select('id,status,created_at').single();
      });
    },
    getMyNotifications: function () {
      return mapped(initClient().rpc('get_personal_notifications'), function (rows) {
        return (rows || []).map(function (n) { n.read = !!n.read_at; return n; });
      });
    },
    markNotificationRead: function (id) { return initClient().from('notifications').update({ read_at: new Date().toISOString() }).eq('id', id); },
    requestAccountClosure: function () { return initClient().rpc('request_account_closure'); },
    getMyBusinesses: function () {
      return cachedCall('my-businesses', 3000, function () {
        var client = initClient();
        // Signed out: skip the query (anon has no access to business_members) and return the same error the API would.
        return client.auth.getSession().then(function (s) {
          if (!s || !s.data || !s.data.session) return { data: null, error: { code: '42501', message: 'permission denied for table business_members', details: null, hint: null } };
          return mapped(client.from('business_members').select('role,business:businesses(id,slug,name,category,plan,status)'), function (rows) {
            return rows.map(function (row) { mapBusiness(row.business); return row; });
          });
        });
      });
    },
    createBusiness: function (name, category, phone) {
      return initClient().rpc('register_business', { business_name: name, business_category: category, business_phone: phone || null }).then(function (r) {
        if (!r.error) clearQueryCache('my-businesses');
        return r;
      });
    },
    getBusinessFull: function (id) {
      return cachedCall('business-full:' + id, 3500, function () {
        return Promise.all([
          initClient().from('businesses').select('*').eq('id', id).single(),
          initClient().rpc('get_business_effective_plan', { target_business:id })
        ]).then(function(parts){
          var row=parts[0], effective=parts[1];
          if(row.error) return row;
          if(!effective.error && effective.data) row.data.plan=effective.data;
          row.data=mapBusiness(row.data);
          return row;
        });
      });
    },
    getBusinessIdentityNumberState: function (businessId) {
      return initClient().rpc('get_business_identity_number_state',{target_business:businessId});
    },
    saveBusinessIdentityNumber: function (businessId, idNumber, consent) {
      return initClient().rpc('save_business_identity_number',{
        target_business:businessId,id_number_input:String(idNumber||'').replace(/\D/g,''),consent:!!consent
      });
    },
    getBusinessVerification: function (id) {
      var latest=initClient().from('business_verifications').select('id,status,provider_reference,submitted_at,reviewed_at,rejection_reason,company_document_path,company_document_status').eq('business_id', id).order('created_at', { ascending:false }).limit(1).maybeSingle();
      var latestDoc=initClient().from('business_verifications').select('company_document_path,company_document_status').eq('business_id', id).not('company_document_path','is',null).order('created_at', { ascending:false }).limit(1).maybeSingle();
      return Promise.all([latest,latestDoc]).then(function(parts){
        if(parts[0].error)return parts[0];
        var row=parts[0].data||null;
        if(row && !row.company_document_path && !parts[1].error && parts[1].data) { row.company_document_path=parts[1].data.company_document_path; row.company_document_status=parts[1].data.company_document_status||'UPLOADED'; }
        return {data:row,error:null};
      });
    },
    updateBusinessProfile: function (id, fields) {
      return invokeFunction('save-business-profile-places', {
        place_id: fields.place_id || null,
        business_id: id,
        short_description: (fields.short_description || '').trim(),
        full_description: (fields.full_description || '').trim(),
        primary_category: (fields.primary_category || '').trim(),
        phone: (fields.phone || '').trim(),
        city: (fields.city || '').trim(),
        province: (fields.province || '').trim(),
        website_url: (fields.website_url || '').trim(),
        facebook_url: (fields.facebook_url || '').trim(),
        instagram_url: (fields.instagram_url || '').trim(),
        tiktok_url: (fields.tiktok_url || '').trim(),
        linkedin_url: (fields.linkedin_url || '').trim()
      });
    },
    submitForReview: function (id) { return initClient().rpc('submit_business_for_review', { target_business: id }); },
    getBusinessServices: function (id) { return mapped(initClient().from('services').select('*').eq('business_id', id).order('name'), function (rows) { return rows.map(mapService); }); },
    addBusinessService: function (id, name, isEmergency, responseMode) {
      return initClient().from('services').insert({
        business_id:id,name:name,is_emergency_service:!!isEmergency,is_active:true,
        emergency_response_mode:isEmergency ? (responseMode || 'PROVIDER_TO_CUSTOMER') : null
      }).select('*').single();
    },
    setServiceEmergencyMode: function (serviceId, mode) {
      return initClient().rpc('set_service_emergency_mode',{target_service:serviceId,requested_mode:mode});
    },
    removeBusinessService: function (id) { return initClient().from('services').delete().eq('id', id); },
    getBusinessPackages: function (id) { return initClient().from('business_packages').select('*').eq('business_id', id).order('sort_order').order('created_at'); },
    createBusinessPackage: function (id, payload) {
      return initClient().from('business_packages').insert({
        business_id:id,
        name:(payload.name || '').trim(),
        description:(payload.description || '').trim() || null,
        price_from_cents:payload.price_from_cents == null ? null : Number(payload.price_from_cents),
        price_to_cents:payload.price_to_cents == null ? null : Number(payload.price_to_cents),
        is_active:payload.is_active !== false
      }).select('*').single();
    },
    deleteBusinessPackage: function (id) { return initClient().from('business_packages').delete().eq('id', id); },
    getBusinessServiceAreas: function (id) { return initClient().from('service_areas').select('*').eq('business_id', id).order('plan_active', { ascending:false }).order('area_name'); },
    searchPlaces: function (text, province) { return initClient().rpc('profind_search_places', {search_text:text,province_filter:province||null,max_results:12}); },
    getPlace: function (id) { return initClient().from('profind_places').select('id,name,province,municipality,latitude,longitude').eq('id',id).eq('selectable',true).maybeSingle(); },
    addServiceArea: function (id, place) {
      if (!place || !place.id) return Promise.resolve({data:null,error:{message:'Choose a service area from the place list.'}});
      return initClient().from('service_areas').insert({business_id:id,place_id:place.id,area_name:place.name,province:place.province,latitude:place.latitude,longitude:place.longitude});
    },
    removeServiceArea: function (id) { return initClient().from('service_areas').delete().eq('id', id); },
    getPublicBusinessMedia: function (id) {
      return initClient().rpc('profind_public_business_media', { target_business: id }).then(function (result) {
        if (!result.error) {
          result.data = (result.data || []).map(function (item) {
            var publicResult = initClient().storage.from('business-media').getPublicUrl(item.storage_path);
            item.public_url = publicResult.data && publicResult.data.publicUrl;
            return item;
          });
        }
        return result;
      });
    },
    getBusinessMedia: function (id) {
      return initClient().from('business_media').select('id,business_id,kind,storage_path,alt_text,sort_order,is_approved,plan_active,created_at').eq('business_id', id).order('sort_order').order('created_at').then(function (result) {
        if (!result.error) {
          result.data = (result.data || []).map(function (item) {
            var publicResult = initClient().storage.from('business-media').getPublicUrl(item.storage_path);
            item.public_url = publicResult.data && publicResult.data.publicUrl;
            return item;
          });
        }
        return result;
      });
    },
    uploadBusinessMedia: function (businessId, kind, file, altText) {
      var allowedKinds = ['LOGO','COVER','GALLERY'];
      if (!file || allowedKinds.indexOf(kind) < 0 || file.size <= 0 || file.size > 8388608) {
        return Promise.resolve({ data:null, error:{ message:'Choose a JPG, PNG or WebP image smaller than 8 MB.' } });
      }
      var form = new FormData();
      form.append('business_id', businessId);
      form.append('kind', kind);
      form.append('alt_text', (altText || '').trim());
      form.append('file', file, file.name || 'business-image');
      return invokeFunctionForm('upload-business-media', form).then(function(result) {
        if (result.error) return result;
        return { data: result.data && result.data.media ? result.data.media : result.data, error:null };
      });
    },
    deleteBusinessMedia: function (item) {
      return initClient().from('business_media').delete().eq('id', item.id).then(function (rowResult) {
        if (rowResult.error) return rowResult;
        return initClient().storage.from('business-media').remove([item.storage_path]);
      });
    },
    uploadBusinessDocument: function (businessId, file, consented) {
      var allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
      var filename = String((file && file.name) || '').toLowerCase();
      var ext = filename.indexOf('.') >= 0 ? filename.split('.').pop() : '';
      var validExtension = ['pdf','jpg','jpeg','png'].indexOf(ext) >= 0;
      var suppliedType = String((file && file.type) || '').toLowerCase();
      var typeAllowed = allowedTypes.indexOf(suppliedType) >= 0 || suppliedType === '' || suppliedType === 'application/octet-stream';
      if (!consented) return Promise.resolve({ data: null, error: { message: 'Consent is required before uploading a verification document.' } });
      if (!file || !file.size || file.size > 12582912 || (!typeAllowed && !validExtension) || (!validExtension && allowedTypes.indexOf(suppliedType) < 0)) {
        return Promise.resolve({ data: null, error: { message: 'Choose a PDF, JPG or PNG file smaller than 12 MB.' } });
      }
      var form = new FormData();
      form.append('business_id', businessId);
      form.append('consented', 'true');
      form.append('document', file, file.name || 'business-document');
      return invokeFunctionForm('upload-business-verification-document', form);
    },
    getBusinessHours: function (id) { return initClient().from('business_hours').select('*').eq('business_id', id).order('day_of_week'); },
    upsertBusinessHours: function (id, day, opens, closes, closed) {
      closed = !!closed;
      opens = opens || null;
      closes = closes || null;
      if (closed) {
        opens = null;
        closes = null;
      } else if (!opens || !closes) {
        return Promise.resolve({ data: null, error: { message: 'Choose both an opening and closing time, or mark the day Closed.' } });
      }
      return initClient().from('business_hours').upsert({
        business_id: id,
        day_of_week: day,
        opens_at: opens,
        closes_at: closes,
        is_closed: closed,
        is_24_hours: false
      }, { onConflict: 'business_id,day_of_week' });
    },
    saveBusinessHoursSchedule: function (id, schedule) {
      return initClient().rpc('save_business_hours_schedule', {
        target_business: id,
        schedule: Array.isArray(schedule) ? schedule : []
      });
    },
    getBusinessAvailability: function (id) {
      return Promise.all([
        initClient().from('business_availability').select('*').eq('business_id', id).maybeSingle(),
        initClient().from('businesses').select('is_emergency_enabled').eq('id', id).single(),
        initClient().from('service_areas').select('radius_km').eq('business_id', id).not('radius_km', 'is', null).limit(1).maybeSingle()
      ]).then(function (parts) {
        var error = parts[0].error || parts[1].error || parts[2].error;
        var data = parts[0].data || {};
        data.emergency_callouts_enabled = !!(parts[1].data && parts[1].data.is_emergency_enabled);
        data.typical_response_minutes = data.response_time_minutes;
        data.service_radius_km = data.emergency_radius_km != null ? Number(data.emergency_radius_km) : (parts[2].data && parts[2].data.radius_km != null ? Math.min(60, Number(parts[2].data.radius_km)) : 15);
        return { data: data, error: error };
      });
    },
    upsertBusinessAvailability: function (id, fields) {
      return initClient().rpc('save_business_emergency_settings', { target_business: id, enabled: !!fields.emergency_callouts_enabled, available: !!fields.available_now, response_minutes: fields.typical_response_minutes, radius_km: fields.service_radius_km });
    },
    setBusinessEnquiryAvailability: function (id, accepting, pauseOption) {
      return initClient().rpc('set_business_enquiry_availability', {
        target_business: id,
        accepting: !!accepting,
        pause_option: accepting ? null : (pauseOption || 'UNTIL_RESUMED')
      });
    },
    getBusinessGrowthIntelligence: function (id) {
      return initClient().rpc('get_business_growth_intelligence', { target_business: id });
    },
    uploadEmergencyCustomerPhoto: function (requestId, manageToken, file) {
      var form = new FormData();
      form.append('request_id', requestId);
      form.append('manage_token', manageToken);
      form.append('photo', file, file.name || 'emergency-photo');
      return initClient().functions.invoke('upload-emergency-customer-photo', { body: form }).then(function (result) {
        return { data: result.data, error: result.error };
      });
    },
    getEmergencyCustomerMedia: function (requestId) {
      return initClient().functions.invoke('get-emergency-customer-media', { body: { request_id: requestId } }).then(function (result) {
        return { data: result.data, error: result.error };
      });
    },
    getBusinessOffers: function (id) { return mapped(initClient().from('offers').select('*').eq('business_id', id).order('created_at', { ascending: false }), function (rows) { return rows.map(mapOffer); }); },
    createOffer: function (id, offer) {
      if (!offer || !offer.honour_agreed) {
        return Promise.resolve({ data: null, error: { message: 'You must agree to honour the published offer.' } });
      }
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data: null, error: { message: 'Please sign in again.' } };
        return initClient().from('offers').insert({
          business_id: id, title: offer.title, description: offer.discount_label || offer.title, discount_type: 'OTHER',
          applicable_service: offer.applicable_service || null,
          applicable_service_id: offer.applicable_service_id || null,
          terms: offer.terms || null,
          exclusions: offer.exclusions || null,
          starts_at: new Date(offer.start_date + 'T00:00:00+02:00').toISOString(),
          ends_at: new Date(offer.end_date + 'T23:59:59+02:00').toISOString(),
          honour_agreed_at: new Date().toISOString(), status: 'DRAFT', created_by: res.data.user.id
        });
      });
    },
    toggleOffer: function (id, active) {
      return active
        ? initClient().rpc('publish_offer', { target_offer: id })
        : initClient().rpc('set_offer_status', { target_offer: id, requested: 'PAUSED' });
    },
    archiveOffer: function (id) { return initClient().rpc('set_offer_status', { target_offer: id, requested: 'CANCELLED' }); },
    redeemOfferClaim: function (code) {
      var value = (code || '').trim().toUpperCase();
      if (!value) return Promise.resolve({ data: null, error: { message: 'Enter a claim code.' } });
      return initClient().rpc('redeem_offer_claim', { claim_code_input: value });
    },
    claimOffer: function (offerId) {
      return initClient().rpc('claim_offer', { target_offer: offerId }).then(function (result) {
        if (result.error) return result;
        return initClient().from('offer_claims').select('id,offer_id,claim_code,status,expires_at,created_at').eq('id', result.data).single();
      });
    },
    disputeOfferClaim: function (claimId, reason) {
      var details = (reason || '').trim();
      if (!details) return Promise.resolve({ data:null, error:{ message:'Please tell us what happened.' } });
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data:null, error:{ message:'Please sign in to report an offer problem.' } };
        return initClient().from('offer_disputes').insert({
          claim_id: claimId,
          opened_by: res.data.user.id,
          reason: 'PROMOTION_NOT_HONOURED',
          details: details,
          status: 'OPEN'
        }).select('id,status,created_at').single();
      });
    },
    followBusiness: function (businessId, notificationsEnabled) {
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data: null, error: { message: 'Please sign in to follow this business.' } };
        return initClient().from('business_follows').upsert({ user_id: res.data.user.id, business_id: businessId, notifications_enabled: notificationsEnabled !== false }, { onConflict: 'user_id,business_id' });
      });
    },
    unfollowBusiness: function (businessId) {
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data: null, error: { message: 'Please sign in to manage followed businesses.' } };
        return initClient().from('business_follows').delete().eq('user_id', res.data.user.id).eq('business_id', businessId);
      });
    },
    getBusinessEnquiries: function (id) { return mapped(initClient().from('enquiries').select('*,messages(id,sender_id,body,read_at,created_at),quotes(id,amount_cents,currency,description,valid_until,status,created_at)').eq('business_id', id).order('created_at', { ascending: false }), function (rows) { return rows.map(mapEnquiry); }); },
    getBusinessEmergencyRequests: function (id) {
      return initClient().from('emergency_requests')
        .select('*,responder:emergency_responders(id,display_name,status,verification_status)')
        .eq('business_id', id).order('created_at', { ascending: false }).limit(25);
    },
    getBusinessEmergencyReliability: function (id) {
      return initClient().from('emergency_reliability')
        .select('accepted_count,declined_count,timeout_count,consecutive_timeouts,no_arrival_count,reliability_score,warning_level,suspended_until')
        .eq('business_id', id).maybeSingle();
    },
    getBusinessEmergencyMetrics: function (id) {
      return initClient().rpc('get_business_emergency_metrics', { target_business: id });
    },
    respondEmergency: function (id, action, reason) {
      return initClient().rpc('respond_emergency', { target_request: id, action: action, reason: reason || null });
    },
    getBusinessEmergencyResponders: function (businessId) {
      return initClient().from('emergency_responders')
        .select('id,business_id,user_id,display_name,mobile_phone,whatsapp_phone,verification_status,identity_verified_at,status,is_active,photo_storage_path,vehicle_type,vehicle_make,vehicle_model,vehicle_color,vehicle_registration,vehicle_vin,vehicle_verification_status,vehicle_verified_at,vehicle_verified_by,vehicle_verification_reason,vehicle_license_disc_path,vehicle_registration_certificate_path,license_disc_vin,license_disc_registration,registration_certificate_vin,registration_certificate_registration,vehicle_registry_status,vehicle_registry_provider,vehicle_registry_checked_at,vehicle_ownership_status,vehicle_ownership_provider,vehicle_ownership_checked_at,vehicle_relationship,vehicle_use_attested_at,created_at,updated_at')
        .eq('business_id', businessId).order('created_at').then(function(result){
          if (result.error) return result;
          var rows=result.data||[];
          return Promise.all(rows.map(function(r){
            if(!r.photo_storage_path)return Promise.resolve(r);
            return initClient().storage.from('emergency-responder-photos').createSignedUrl(r.photo_storage_path,300).then(function(signed){
              r.photo_url=signed.data&&signed.data.signedUrl||null; return r;
            }).catch(function(){return r;});
          })).then(function(mappedRows){return {data:mappedRows,error:null};});
        });
    },
    createEmergencyResponder: function (businessId, name, mobile, whatsapp, vehicleType, vehicleMake, vehicleModel, vehicleColor, vehicleRegistration, vehicleVin) {
      return initClient().rpc('create_emergency_responder_full_v4', {
        target_business: businessId, responder_name: name, mobile: mobile, whatsapp: whatsapp || null,
        vehicle_type_input: vehicleType || null, vehicle_make_input: vehicleMake || null,
        vehicle_model_input: vehicleModel || null, vehicle_color_input: vehicleColor || null,
        vehicle_registration_input: vehicleRegistration || null, vehicle_vin_input: vehicleVin || null
      });
    },
    updateEmergencyResponder: function (responderId, name, mobile, whatsapp, active, vehicleType, vehicleMake, vehicleModel, vehicleColor, vehicleRegistration, vehicleVin, discVin, discRegistration, certVin, certRegistration) {
      return initClient().rpc('update_emergency_responder_full_v5', {
        target_responder: responderId, responder_name: name, mobile: mobile,
        whatsapp: whatsapp || null, active: active !== false,
        vehicle_type_input: vehicleType || null, vehicle_make_input: vehicleMake || null,
        vehicle_model_input: vehicleModel || null, vehicle_color_input: vehicleColor || null,
        vehicle_registration_input: vehicleRegistration || null, vehicle_vin_input: vehicleVin || null,
        license_disc_vin_input: discVin || null,
        license_disc_registration_input: discRegistration || null,
        registration_certificate_vin_input: certVin || null,
        registration_certificate_registration_input: certRegistration || null
      });
    },
    getEmergencyResponderIdentityState: function (responderId) {
      return initClient().rpc('get_emergency_responder_identity_state',{target_responder:responderId});
    },
    saveEmergencyResponderIdentityNumber: function (responderId,idNumber,consent) {
      return initClient().rpc('save_emergency_responder_identity_number',{
        target_responder:responderId,id_number_input:String(idNumber||'').replace(/\D/g,''),consent:!!consent
      });
    },
    saveEmergencyResponderVehicleRelationship: function (responderId,relationship,consent) {
      return initClient().rpc('save_emergency_responder_vehicle_relationship',{
        target_responder:responderId,relationship_input:String(relationship||'').toUpperCase(),consent:!!consent
      });
    },
    getEmergencyResponderCredentialRequirements: function (responderId) {
      return initClient().rpc('list_emergency_responder_credential_requirements',{target_responder:responderId});
    },
    uploadEmergencyResponderCredential: function (responderId,payload,file) {
      var form=new FormData();
      form.append('responder_id',responderId);
      form.append('credential_type',payload.credential_type||'');
      form.append('authority',payload.authority||'');
      form.append('registration_number',payload.registration_number||'');
      form.append('expires_on',payload.expires_on||'');
      form.append('file',file,file.name||'credential');
      return invokeFunctionForm('upload-emergency-responder-credential',form);
    },
    uploadEmergencyResponderPhoto: function (responderId, file) {
      var allowed = ['image/jpeg','image/png','image/webp'];
      var filename=String((file&&file.name)||'').toLowerCase();
      var ext=filename.indexOf('.')>=0?filename.split('.').pop():'';
      var validExt=['jpg','jpeg','png','webp'].indexOf(ext)>=0;
      var suppliedType=String((file&&file.type)||'').toLowerCase();
      var typeAllowed=allowed.indexOf(suppliedType)>=0||suppliedType===''||suppliedType==='application/octet-stream';
      if (!file || !file.size || file.size > 6291456 || (!typeAllowed && !validExt) || (!validExt && allowed.indexOf(suppliedType)<0)) {
        return Promise.resolve({data:null,error:{message:'Choose a JPG, PNG or WebP image smaller than 6 MB.'}});
      }
      var form = new FormData();
      form.append('responder_id', responderId);
      form.append('photo', file, file.name || 'responder-photo');
      return invokeFunctionForm('upload-emergency-responder-photo', form);
    },
    getBusinessPayoutEligibility: function (businessId) {
      return initClient().rpc('get_business_payout_eligibility', { target_business: businessId });
    },
    getPayoutBanks: function (businessId) {
      return invokeFunction('paystack-payout-profile', { action:'BANKS', business_id:businessId });
    },
    savePayoutProfile: function (businessId, payload) {
      return invokeFunction('paystack-payout-profile', {
        action:'SAVE', business_id:businessId,
        account_holder_name:(payload.account_holder_name||'').trim(),
        bank_name:(payload.bank_name||'').trim(),
        bank_code:(payload.bank_code||'').trim(),
        account_number:(payload.account_number||'').replace(/\s+/g,''),
        account_type:(payload.account_type||'').trim()
      });
    },
    uploadResponderVehicleEvidence: function (responderId, kind, file) {
      var form = new FormData();
      form.append('responder_id', responderId);
      form.append('kind', kind);
      form.append('file', file, file.name || 'vehicle-evidence');
      return invokeFunctionForm('upload-responder-vehicle-evidence', form);
    },
    verifyResponderVehicleFree: function (responderId) {
      return invokeFunction('verify-responder-vehicle', { responder_id: responderId });
    },
    startEmergencyResponderVerification: function (responderId) {
      return invokeFunction('didit-create-responder-session', { responder_id: responderId });
    },
    assignEmergencyResponder: function (requestId, responderId) {
      return initClient().rpc('assign_emergency_responder', { target_request: requestId, target_responder: responderId });
    },
    setEmergencyResponderStatus: function (responderId, status) {
      return initClient().rpc('set_emergency_responder_status', { target_responder: responderId, requested: status });
    },
    getEmergencyAvailableSlots: function (businessId) {
      return initClient().rpc('emergency_available_slots', { target_business: businessId });
    },
    startEmergencyResponse: function (requestId) {
      return initClient().rpc('start_emergency_response', { target_request: requestId });
    },
    recordEmergencyLocation: function (requestId, lat, lon, accuracy, heading, speed) {
      return initClient().rpc('record_emergency_location', {
        target_request: requestId, lat: lat, lon: lon,
        accuracy: accuracy == null ? null : accuracy,
        heading: heading == null ? null : heading,
        speed: speed == null ? null : speed
      });
    },
    markEmergencyArrived: function (requestId, lat, lon, accuracy) {
      return initClient().rpc('mark_emergency_arrived', {
        target_request: requestId, lat: lat, lon: lon, accuracy: accuracy == null ? null : accuracy
      });
    },
    startCustomerNoShowWait: function (requestId) {
      return initClient().rpc('start_customer_no_show_wait', { target_request: requestId });
    },
    reportCustomerNoShow: function (requestId) {
      return initClient().rpc('report_customer_no_show', { target_request: requestId });
    },
    cancelEmergencyRequest: function (requestId, reason) {
      return initClient().rpc('cancel_emergency_request', { target_request: requestId, reason: reason || null });
    },
    customerEmergencyOnWay: function (requestId) {
      return initClient().rpc('customer_emergency_on_way', { target_request: requestId });
    },
    customerEmergencyArrived: function (requestId, lat, lon, accuracy) {
      return initClient().rpc('customer_emergency_arrived', {
        target_request: requestId,
        lat: lat,
        lon: lon,
        accuracy: accuracy == null ? null : accuracy
      });
    },
    saveBusinessCalloutSettings: function (businessId, feeCents, protection) {
      return initClient().rpc('save_business_callout_settings', {
        target_business: businessId, fee_cents: Number(feeCents || 0), protection: !!protection
      });
    },
    getBusinessCalloutFeeState: function (businessId) {
      return initClient().rpc('get_business_callout_fee_state', { target_business: businessId });
    },
    requestBusinessCalloutFeeChange: function (businessId, feeCents, reason) {
      return initClient().rpc('request_business_callout_fee_change', {
        target_business: businessId, fee_cents:Number(feeCents||0), reason:(reason||'').trim()||null
      });
    },
    getBusinessEmergencyConfiguration: function (businessId) {
      return initClient().rpc('get_business_emergency_configuration',{target_business:businessId});
    },
    saveBusinessEmergencyConfiguration: function (businessId, mode, premisesCapacity) {
      return initClient().rpc('save_business_emergency_configuration',{
        target_business:businessId,operating_mode:mode,premises_capacity:Number(premisesCapacity||1)
      });
    },
    saveBusinessEmergencyPremisesLocation: function (businessId, lat, lon, accuracy) {
      return initClient().rpc('save_business_emergency_premises_location',{
        target_business:businessId,
        lat:Number(lat),
        lon:Number(lon),
        accuracy:accuracy==null?null:Number(accuracy)
      });
    },
    saveBusinessFeeShieldPreference: function (businessId, enabled) {
      return initClient().rpc('save_business_fee_shield_preference',{
        target_business:businessId,enabled:!!enabled
      });
    },
    getBusinessEmergencyFeeState: function (businessId, feeType) {
      return initClient().rpc('get_business_emergency_fee_state',{
        target_business:businessId,target_fee_type:String(feeType||'CALLOUT').toUpperCase()
      });
    },
    requestBusinessEmergencyFeeChange: function (businessId, feeType, feeCents, reason) {
      return initClient().rpc('request_business_emergency_fee_change',{
        target_business:businessId,target_fee_type:String(feeType||'CALLOUT').toUpperCase(),
        fee_cents:Number(feeCents||0),reason:(reason||'').trim()||null
      });
    },
    getEmergencyLocationUpdates: function (requestId) {
      return initClient().from('emergency_location_updates')
        .select('id,emergency_request_id,responder_id,latitude,longitude,accuracy_m,heading,speed_mps,recorded_at')
        .eq('emergency_request_id', requestId).order('recorded_at', { ascending:false }).limit(1);
    },
    uploadEmergencyEvidence: function (requestId, lat, lon, accuracy, photoFile) {
      if (!photoFile || !photoFile.size) return Promise.resolve({ data:null, error:{ message:'Take a live photo first.' } });
      var form = new FormData();
      form.append('request_id', requestId);
      form.append('latitude', String(lat));
      form.append('longitude', String(lon));
      form.append('accuracy_m', String(accuracy == null ? '' : accuracy));
      form.append('photo', photoFile, photoFile.name || 'arrival-photo.jpg');
      return invokeFunctionForm('upload-emergency-evidence', form);
    },
    respondToEnquiry: function (id, text) { return initClient().rpc('respond_to_enquiry', { target_enquiry: id, response_text: text }); },
    getEnquiryMessages: function (id) { return initClient().from('messages').select('id,enquiry_id,sender_id,body,read_at,created_at').eq('enquiry_id', id).order('created_at'); },
    sendEnquiryMessage: function (id, body) {
      var text = (body || '').trim();
      if (!text || text.length > 4000) return Promise.resolve({ data: null, error: { message: 'Write a message of 4,000 characters or fewer.' } });
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data: null, error: { message: 'Please sign in again.' } };
        return initClient().from('messages').insert({ enquiry_id: id, sender_id: res.data.user.id, body: text }).select('id,enquiry_id,sender_id,body,read_at,created_at').single();
      });
    },
    markEnquiryMessagesRead: function (id) {
      return initClient().auth.getUser().then(function (res) {
        if (!res.data.user) return { data: null, error: { message: 'Please sign in again.' } };
        return initClient().from('messages').update({ read_at: new Date().toISOString() }).eq('enquiry_id', id).neq('sender_id', res.data.user.id).is('read_at', null);
      });
    },
    setEnquiryStatus: function (id, status) { return initClient().rpc('set_enquiry_status', { target_enquiry: id, requested: status }); },
    setQuoteStatus: function (id, status) { return initClient().rpc('set_quote_status', { target_quote: id, requested: status }); },
    createQuote: function (enquiryId, businessId, amountCents, description, validUntil) {
      var validUntilIso = validUntil ? new Date(validUntil + 'T23:59:59+02:00').toISOString() : null;
      return initClient().rpc('create_quote', {
        target_enquiry: enquiryId,
        amount_cents: Number(amountCents),
        description: (description || '').trim(),
        valid_until: validUntilIso,
        send_now: true
      });
    },
    getBusinessReviews: function (id) { return mapped(initClient().from('reviews').select('*').eq('business_id', id).order('created_at', { ascending: false }), function (rows) { return rows.map(mapReview); }); },
    getBusinessAnalytics: function (id) {
      return initClient().rpc('get_business_analytics_30d', { target_business: id });
    },
    getBusinessNotifications: function (id) {
      return initClient().from('notifications').select('id,type,title,body,data,read_at,created_at').eq('business_id', id).order('created_at', { ascending:false }).limit(12);
    },
    getBusinessNotificationPreferences: function (businessId) {
      return initClient().auth.getUser().then(function(res){
        var user=res.data&&res.data.user;
        if(!user)return {data:null,error:{message:'Please sign in again.'}};
        return initClient().from('business_notification_preferences')
          .select('business_id,user_id,email_enquiries,in_app_enquiries,whatsapp_enquiries,emergency_alerts,marketing,security_alerts')
          .eq('business_id',businessId).eq('user_id',user.id).maybeSingle();
      });
    },
    saveBusinessNotificationPreferences: function (businessId, payload) {
      return initClient().auth.getUser().then(function(res){
        var user=res.data&&res.data.user;
        if(!user)return {data:null,error:{message:'Please sign in again.'}};
        return initClient().from('business_notification_preferences').upsert({
          business_id:businessId,user_id:user.id,
          email_enquiries:payload.email_enquiries!==false,
          in_app_enquiries:true,
          whatsapp_enquiries:payload.whatsapp_enquiries===true,
          emergency_alerts:true,
          marketing:false,
          security_alerts:true,
          updated_at:new Date().toISOString()
        },{onConflict:'business_id,user_id'}).select('email_enquiries,whatsapp_enquiries,emergency_alerts,security_alerts').single();
      });
    },
    getBusinessSubscription: function (id) { return initClient().from('subscriptions').select('id,plan,status,amount_cents,currency,current_period_end,cancel_at_period_end,last_payment_status,grace_period_ends_at,provider,payment_method_summary').eq('business_id', id).order('created_at', { ascending: false }).limit(1).maybeSingle(); },
    replyToReview: function (id, text) { return initClient().rpc('respond_to_review', { target_review: id, response_text: text }); },
    getMyAdminRole: function () {
      return initClient().auth.getUser().then(function (userResult) {
        var user = userResult.data && userResult.data.user;
        if (!user) return { data: null, error: { message: 'Please sign in again.' } };
        return initClient().from('admin_users').select('role,active').eq('user_id', user.id).eq('active', true).maybeSingle();
      });
    },
    getAdminBusinesses: function () {
      return initClient().from('businesses')
        .select('*,services(id,name,is_active,is_emergency_service),service_areas(id,area_name,radius_km,is_primary),business_hours(day_of_week,opens_at,closes_at,is_closed,is_24_hours),business_media(id,kind,storage_path,alt_text,is_approved,created_at),business_verifications(id,status,legal_name,registration_number,company_document_path,company_document_status,submitted_at,reviewed_at,rejection_reason,created_at,updated_at)')
        .in('status', ['UNDER_REVIEW','RESUBMITTED','CHANGES_REQUESTED','LAUNCH_READY','LIVE','SUSPENDED','REJECTED'])
        .order('updated_at', { ascending: false }).then(function (result) {
          if (!result.error) result.data = (result.data || []).map(function(row){
          if(Array.isArray(row.business_verifications)){
            row.business_verifications.sort(function(a,b){
              return new Date(b.updated_at||b.created_at||0).getTime()-new Date(a.updated_at||a.created_at||0).getTime();
            });
          }
          return mapBusiness(row);
        });
          return result;
        });
    },
    adminReviewBusiness: function (businessId, decision, notes) {
      return initClient().rpc('admin_review_business', { target_business: businessId, decision: decision, notes: notes || null });
    },
    createVerificationDocumentUrl: function (path) { return initClient().storage.from('verification-documents').createSignedUrl(path, 300); },
    getPlatformSettings: function () { return initClient().from('platform_settings').select('platform_state,updated_at').eq('singleton', true).single(); },
    activateLaunchReadyBusinesses: function () { return initClient().rpc('activate_launch_ready_businesses'); },
    getServiceCategories: function () { return cachedCall('service-categories', 300000, function () { return initClient().rpc('list_service_categories'); }); },
    getEmergencyCategories: function (searchText) {
      return initClient().rpc('list_emergency_categories', { search_text: (searchText || '').trim() || null });
    },
    resolveEmergencyCategory: function (category) {
      return initClient().rpc('resolve_emergency_category', { wanted_category: category });
    },
    getAdminAuditLog: function () { return initClient().from('audit_logs').select('id,action,business_id,entity_type,created_at,after_data').order('created_at', { ascending: false }).limit(50); },
    getAdminReviewReports: function () {
      return initClient().from('review_reports')
        .select('id,review_id,reason,details,status,created_at,review:reviews(id,rating,title,body,status,business_id,business:businesses(id,name))')
        .eq('status','OPEN').order('created_at',{ascending:false}).limit(50);
    },
    getAdminOfferDisputes: function () {
      return initClient().from('offer_disputes')
        .select('id,claim_id,reason,details,status,resolution,created_at,claim:offer_claims(id,claim_code,offer:offers(id,title,business_id,business:businesses(id,name)))')
        .eq('status','OPEN').order('created_at',{ascending:false}).limit(50);
    },
    getAdminSubscriptions: function () {
      return initClient().from('subscriptions')
        .select('id,business_id,plan,status,amount_cents,currency,current_period_end,last_payment_status,provider,created_at,business:businesses(id,name)')
        .order('created_at',{ascending:false}).limit(100);
    },
    getAdminCalloutFeeChanges: function () {
      return initClient().rpc('admin_list_callout_fee_changes');
    },
    getAdminBusinessCertifications: function () {
      return initClient().rpc('admin_list_business_certifications');
    },
    adminReviewBusinessCertification: function (certificationId, decision, notes) {
      return initClient().rpc('admin_review_business_certification', {
        target_certification: certificationId,
        decision: decision,
        notes: (notes || '').trim() || null
      });
    },
    createCertificationDocumentUrl: function (path) {
      return initClient().storage.from('business-certifications').createSignedUrl(path, 300);
    },
    getAdminEmergencyResponderCredentials: function () {
      return initClient().rpc('admin_list_emergency_responder_credentials');
    },
    adminReviewEmergencyResponderCredential: function (credentialId, decision, notes) {
      return initClient().rpc('admin_review_emergency_responder_credential',{
        target_credential:credentialId,decision:String(decision||'').toUpperCase(),notes:(notes||'').trim()||null
      });
    },
    createResponderCredentialDocumentUrl: function (path) {
      return initClient().storage.from('emergency-responder-credentials').createSignedUrl(path,300);
    },
    adminReviewCalloutFeeChange: function (requestId, decision, notes) {
      return initClient().rpc('admin_review_callout_fee_change', {
        target_request: requestId,
        decision: decision,
        notes: (notes || '').trim() || null
      });
    },
    getAdminServiceCategories: function () {
      return initClient().from('service_categories')
        .select('slug,name,group_name,aliases,emergency_eligible,is_active,sort_order')
        .order('sort_order').order('name');
    },
    getAdminUsers: function () { return initClient().rpc('admin_list_users',{limit_rows:100}); },
    getAdminAnalytics: function () {
      return initClient().rpc('admin_get_platform_analytics_30d');
    },
    getAdminReserveOverview: function () {
      return initClient().rpc('admin_reserve_overview');
    },
    getAdminReserveTrustQueue: function () {
      return initClient().rpc('admin_reserve_trust_queue');
    },
    adminReviewReserveFeeShield: function (businessId, decision, notes) {
      return initClient().rpc('admin_review_reserve_feeshield',{target_business:businessId,decision:decision,notes:notes||null});
    },
    adminResolveReserveFeeShieldDispute: function (bookingId, decision, captureCents, notes) {
      return initClient().rpc('admin_resolve_reserve_feeshield_dispute',{target_booking:bookingId,target_decision:decision,target_capture_cents:captureCents==null?null:Number(captureCents),target_notes:notes||null});
    },
    adminResolveCustomerRatingDispute: function (disputeId, decision, notes) {
      return initClient().rpc('admin_resolve_customer_rating_dispute',{target_dispute:disputeId,decision:decision,notes:notes||null});
    },
    adminUpsertServiceCategory: function (payload) {
      return initClient().rpc('admin_upsert_service_category',{
        category_slug:payload.slug,
        category_name:payload.name,
        category_group:payload.group_name,
        category_aliases:payload.aliases || [],
        emergency:!!payload.emergency_eligible,
        active:payload.is_active !== false,
        sort_value:Number(payload.sort_order)||0
      });
    },
    moderateReview: function (reviewId, decision, notes) {
      return initClient().rpc('moderate_review',{target_review:reviewId,decision:decision,notes:notes || null});
    },
    resolveReviewReport: function (reportId, decision, notes) {
      return initClient().rpc('resolve_review_report',{target_report:reportId,decision:decision,resolution_notes:notes || null});
    },
    resolveOfferDispute: function (disputeId, decision, resolution) {
      return initClient().rpc('resolve_offer_dispute',{target_dispute:disputeId,decision:decision,resolution_text:resolution || null});
    },
    createEnquiry: function (payload) { return invokePublicFunction('create-enquiry', payload, 30000); },
    claimGuestJourney: function (claimToken) { return invokeFunction('claim-guest-journey', { claim_token: claimToken }); },
    claimGuestJourneysByEmail: function () { return invokeFunction('claim-guest-by-email', {}); },
    resendGuestClaim: function (claimToken) { return invokePublicFunction('resend-guest-claim', { claim_token: claimToken }, 30000); },
    getEmergencyProviderOptions: function (payload) { return invokePublicFunction('emergency-provider-options', payload, 15000); },
    createEmergencyRequest: function (payload) { return invokePublicFunction('create-emergency-request', payload, 30000); },
    createDiditSession: function (businessId) {
      return initClient().rpc('get_business_identity_number_state',{target_business:businessId}).then(function(state){
        if (state.error) return {data:null,error:state.error};
        if (!state.data || !state.data.provided) {
          return {data:null,error:{message:'Enter and save your South African ID number before starting identity verification.',status:409,code:'ID_NUMBER_REQUIRED'}};
        }
        return invokeFunction('didit-create-session', { business_id: businessId, action: 'START' });
      });
    },
    checkDiditSession: function (businessId, sessionId) { return invokeFunction('didit-create-session', { business_id: businessId, action: 'STATUS', session_id: sessionId || null }); },
    startBillingCheckout: function (businessId, plan) { return invokeFunction('paystack-billing', { action: 'INITIALIZE', business_id: businessId, plan: String(plan || '').toUpperCase() }); },
    getBillingStatus: function (businessId) { return invokeFunction('paystack-billing', { action: 'STATUS', business_id: businessId }); },
    manageBillingSubscription: function (businessId) { return invokeFunction('paystack-billing', { action: 'MANAGE', business_id: businessId }); },
    scheduleBillingDowngrade: function (businessId, targetPlan) { return invokeFunction('paystack-billing', { action: 'SCHEDULE_DOWNGRADE', business_id: businessId, target_plan: String(targetPlan || '').toUpperCase() }); },
    cancelScheduledBillingDowngrade: function (businessId) { return invokeFunction('paystack-billing', { action: 'CANCEL_SCHEDULED_DOWNGRADE', business_id: businessId }); },
    cancelBillingSubscription: function (businessId) { return invokeFunction('paystack-billing', { action: 'CANCEL', business_id: businessId }); },
    searchNowAI: function (payload) { return invokePublicFunction('now-ai-search-places', payload, 30000); },
    createDemandWatch: function (payload) { return invokePublicFunction('demand-watch', Object.assign({ action: 'CREATE' }, payload || {}), 30000); },
    confirmDemandWatch: function (watchId, token) { return invokePublicFunction('demand-watch', { action: 'CONFIRM', watch_id: watchId, token: token }, 30000); },
    stopGuestDemandWatch: function (watchId, token) { return invokePublicFunction('demand-watch', { action: 'UNSUBSCRIBE_GUEST', watch_id: watchId, token: token }, 30000); },
    getDemandWatches: function () { return invokeFunction('demand-watch', { action: 'LIST' }); },
    updateDemandWatch: function (watchId, command, payload) { return invokeFunction('demand-watch', Object.assign({ action: 'UPDATE', watch_id: watchId, command: command }, payload || {})); },
    getBusinessDemandSignals: function (businessId) { return invokeFunction('demand-watch', { action: 'BUSINESS_INSIGHTS', business_id: businessId }); },
    getAdminDemandSignals: function () { return invokeFunction('demand-watch', { action: 'ADMIN_INSIGHTS' }); },
    getBusinessRegistrationResume: function (businessId, sourceStage) { return invokeFunction('business-registration-resume', { business_id: businessId, source_stage: sourceStage || null }); },
    askNowAIAgent: function (payload) { return invokePublicFunction('now-ai-agent-places', payload, 30000); },
    askNowAIAboutBusiness: function (payload) { return invokePublicFunction('now-ai-business-super', payload, 30000); },
    listBusinessAIKnowledge: function (businessId) { return invokeFunction('now-ai-business-knowledge', { action: 'LIST', business_id: businessId }); },
    saveBusinessAIKnowledge: function (businessId, payload) { return invokeFunction('now-ai-business-knowledge', Object.assign({ action: 'UPSERT', business_id: businessId }, payload || {})); },
    deleteBusinessAIKnowledge: function (businessId, id) { return invokeFunction('now-ai-business-knowledge', { action: 'DELETE', business_id: businessId, id: id }); }
  };

  window.ProFindAuth = ProFindAuth;
  window.ProFindData = ProFindData;
})();


(function () {
  'use strict';
  var serial = 0;
  window.ProFindPlaces = {
    mount: function (input, options) {
      if (!input || input.dataset.placePicker) return;
      options = options || {};
      input.dataset.placePicker = 'true';
      input.autocomplete = 'off';
      input.spellcheck = false;
      input.style.fontSize = '16px';
      var selected = null, items = [], active = -1, version = 0, timer;
      var host = document.createElement('div');
      host.className = 'pf-place-picker';
      input.parentNode.insertBefore(host, input);
      host.appendChild(input);
      var list = document.createElement('div');
      list.id = 'pf-place-list-' + (++serial);
      list.className = 'pf-place-list';
      list.setAttribute('role', 'listbox');
      list.hidden = true;
      host.appendChild(list);
      var note = document.createElement('div');
      note.className = 'pf-place-note';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      note.textContent = 'Type a town, city or suburb, then select its province below.';
      host.appendChild(note);
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-controls', list.id);
      input.setAttribute('aria-label', options.label || 'South African town, city or suburb');
      function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
      function pick(place) {
        selected = place; input.value = place.name; input.dataset.placeId = place.id;
        input.setCustomValidity('');
        note.textContent = [place.municipality, place.province].filter(Boolean).join(' · ');
        if (options.provinceInput) options.provinceInput.value = place.province;
        close();
      }
      function render(rows) {
        items = rows; active = -1; list.replaceChildren();
        rows.forEach(function (place, index) {
          var button = document.createElement('button'); button.type = 'button'; button.id = list.id + '-' + index;
          button.setAttribute('role', 'option'); button.setAttribute('aria-selected', 'false'); button.tabIndex = -1;
          var name = document.createElement('strong'); name.textContent = place.name;
          var detail = document.createElement('span'); detail.textContent = [place.municipality, place.province].filter(Boolean).join(' · ');
          button.append(name, detail);
          button.addEventListener('mousedown', function (e) { e.preventDefault(); });
          button.addEventListener('click', function () { pick(place); input.focus(); });
          list.appendChild(button);
        });
        list.hidden = !rows.length; input.setAttribute('aria-expanded', rows.length ? 'true' : 'false');
        note.textContent = rows.length ? 'Select the correct place and province.' : 'No matching place. Check the spelling, then ask ARIA Support to help with a missing place.';
      }
      function search() {
        var current = ++version, text = input.value.trim();
        if (text.length < 2) { close(); note.textContent = 'Type at least two letters to find a place.'; return; }
        note.textContent = 'Finding places…';
        window.ProFindData.searchPlaces(text).then(function (r) {
          if (current !== version || !input.isConnected) return;
          if (r.error) { close(); note.textContent = 'Places could not load. Type again to retry.'; return; }
          render(r.data || []);
        }).catch(function () { if (current === version) { close(); note.textContent = 'Places could not load. Type again to retry.'; } });
      }
      input.addEventListener('input', function () {
        selected = null; delete input.dataset.placeId; input.setCustomValidity('Choose a place from the list.');
        if (options.provinceInput) options.provinceInput.value = '';
        version++; close(); clearTimeout(timer); timer = setTimeout(search, 180);
      });
      input.addEventListener('focus', function () { if (!selected && input.value.trim().length >= 2) search(); });
      input.addEventListener('blur', function () { setTimeout(close, 180); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key === 'Enter' && !list.hidden && active >= 0) { e.preventDefault(); pick(items[active]); return; }
        if (!list.hidden && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
          e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
          Array.from(list.children).forEach(function (el, i) { el.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
          input.setAttribute('aria-activedescendant', list.children[active].id); list.children[active].scrollIntoView({block:'nearest'});
        }
      });
      input.profindSelectedPlace = function () { return selected; };
      if (options.provinceInput) { options.provinceInput.readOnly = true; options.provinceInput.setAttribute('aria-label', 'Province from selected place'); }
      var original = input.value.trim(), initialVersion = version;
      if (options.placeId) {
        window.ProFindData.getPlace(options.placeId).then(function (r) { if (version === initialVersion && !r.error && r.data) pick(r.data); });
      } else if (original) {
        window.ProFindData.searchPlaces(original, options.province || null).then(function (r) {
          if (version !== initialVersion || r.error) return;
          var exact = (r.data || []).filter(function (p) { return p.exact; });
          if (exact.length === 1) pick(exact[0]);
          else note.textContent = 'Please select your town and province from the list before saving.';
        });
      }
    }
  };
  var style = document.createElement('style');
  style.textContent = '.pf-place-picker{position:relative;flex:1;min-width:0;width:100%}.pf-place-picker>input{width:100%}.pf-place-list{position:relative;z-index:5;margin-top:6px;max-height:260px;overflow-y:auto;border:1px solid #d8e1ed;border-radius:14px;background:#fff;box-shadow:0 8px 24px #142d4814}.pf-place-list[hidden]{display:none}.pf-place-list>button{display:flex;flex-direction:column;gap:3px;width:100%;padding:12px 14px;text-align:left;background:#fff;border:0;border-bottom:1px solid #eef2f7;color:#152d48;cursor:pointer;font:inherit}.pf-place-list>button:hover,.pf-place-list>button[aria-selected=true]{background:#eef5ff}.pf-place-list>button>span{font-size:12px;color:#50627b}.pf-place-note{font-size:12px;line-height:1.5;color:#53647b;margin-top:6px}.pfbo2-chip-input:has(.pf-place-picker){align-items:flex-start}';
  document.head.appendChild(style);
})();
